import {
  formatCurrency,
  formatCurrencyTotal,
  formatMoney,
  formatWithoutCurrency,
  getThemeColor,
  getRouteQueryParam,
  isMediumUpBreakpoint,
  isPadBreakpoint,
  isPcBreakpoint,
  isPhoneBreakpoint,
  isUltrawideBreakpoint,
  machineGeneralizerText,
  machineIdentifierText,
  sameValue,
  serializeToQueryParams,
  setFavicon,
  setRouteQueryParam,
  statuscolor,
  validateUpdate,
} from "@/helpers/appGlobals";

export default {
  name: "AppGlobalsMixin",

  methods: {
    formatCurrencyTotal,
    formatMoney,
    formatCurrency,
    formatWithoutCurrency,
    SameValue: sameValue,
    serializeToQueryParams,
    setFavicon,
    getQueryParam(querykey, fallback) {
      return getRouteQueryParam(this.$route, querykey, fallback);
    },
    getThemeColor(colorName, fallback) {
      return getThemeColor(this.$vuetify, colorName, fallback);
    },
    setQueryParam(querykey, update) {
      return setRouteQueryParam(this.$router, this.$route, querykey, update);
    },
    validateUpdate,
    statuscolor,
    machineGeneralizerText,
    machineIdentifierText,
  },

  computed: {
    isUltrawideBool() {
      return isUltrawideBreakpoint(this.$vuetify?.display);
    },

    isPcBool() {
      return isPcBreakpoint(this.$vuetify?.display);
    },

    isMediumUpBool() {
      return isMediumUpBreakpoint(this.$vuetify?.display);
    },

    isPadBool() {
      return isPadBreakpoint(this.$vuetify?.display);
    },

    isPhoneBool() {
      return isPhoneBreakpoint(this.$vuetify?.display);
    },
  },
};